import { getStoredToken } from '../auth/cognito';

const API_URL = 'https://0emko5cw6f.execute-api.ca-central-1.amazonaws.com/prod';

function getAuthHeaders() {
  const token = getStoredToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token || ''
  };
}

export interface TeamMember {
  userId: string;
  orgId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  status: string;
  invitedAt: string;
  lastActive: string | null;
}

export async function getTeamMembers(): Promise<TeamMember[]> {
  try {
    const res = await fetch(`${API_URL}/org/users`, { headers: getAuthHeaders() });
    const data = await res.json();
    return data.users || [];
  } catch {
    return [];
  }
}

export async function inviteTeamMember(
  email: string,
  firstName: string,
  lastName: string,
  role: string = 'user'
): Promise<{ success?: boolean; error?: string; message?: string }> {
  try {
    const res = await fetch(`${API_URL}/admin/invite`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ email, firstName, lastName, role })
    });
    return await res.json();
  } catch {
    return { error: 'Network error. Please try again.' };
  }
}

export async function getInviteStatus(userId: string): Promise<{ accepted: boolean; userStatus: string }> {
  try {
    const res = await fetch(`${API_URL}/org/users/${userId}/status`, { headers: getAuthHeaders() });
    return await res.json();
  } catch {
    return { accepted: false, userStatus: 'UNKNOWN' };
  }
}

export async function resendInvite(userId: string): Promise<{ success?: boolean; error?: string; message?: string }> {
  try {
    const res = await fetch(`${API_URL}/org/users/${userId}/resend`, {
      method: 'POST',
      headers: getAuthHeaders()
    });
    return await res.json();
  } catch {
    return { error: 'Network error. Please try again.' };
  }
}

export async function deleteInvite(userId: string): Promise<{ success?: boolean; error?: string }> {
  try {
    const res = await fetch(`${API_URL}/org/users/${userId}/invite`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return await res.json();
  } catch {
    return { error: 'Network error. Please try again.' };
  }
}

export async function updateTeamMemberRole(userId: string, role: string): Promise<{ success?: boolean; error?: string }> {
  try {
    const res = await fetch(`${API_URL}/org/users/${userId}/role`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ role })
    });
    return await res.json();
  } catch {
    return { error: 'Network error. Please try again.' };
  }
}

export async function removeTeamMember(userId: string): Promise<{ success?: boolean; error?: string }> {
  try {
    const res = await fetch(`${API_URL}/org/users/${userId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return await res.json();
  } catch {
    return { error: 'Network error. Please try again.' };
  }
}
